import React from 'react';
import {
  Box,
  Typography,
  Switch,
  Stack,
  Divider,
  IconButton,
  Tooltip,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { getNome, getDescricao, menuPalette } from '../utils/dashboardHelpers';

const ItemRow = ({ item, onEdit, onDelete, showHandle, onToggleActive, channelLabel }) => (
  <Box
    display="flex"
    alignItems="center"
    gap={1.5}
    px={1.5}
    py={1.25}
    sx={{
      position: 'relative',
      borderBottom: `1px dashed ${menuPalette.border}`,
      '&:last-child': { borderBottom: 'none' },
      background: item.ativo
        ? 'linear-gradient(90deg, rgba(31,79,191,0.04), rgba(255,255,255,0.92))'
        : 'rgba(243,243,246,0.7)',
      borderRadius: 1,
      transition: 'all .2s ease',
      opacity: item.ativo ? 1 : 0.72,
      '&:hover': { boxShadow: 'inset 0 0 0 1px rgba(31,79,191,0.18)', transform: 'translateX(2px)' },
      '&:hover .item-secondary-actions': { opacity: 1 },
    }}
  >
    <Box width={28} color="text.disabled" display={showHandle ? 'flex' : 'none'} alignItems="center" justifyContent="center">
      <DragIndicatorIcon fontSize="small" />
    </Box>

    <Box flex={1} minWidth={0}>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          letterSpacing: '0.02em',
          color: menuPalette.ink,
          lineHeight: 1.3,
          textDecoration: item.ativo ? 'none' : 'line-through',
          textDecorationColor: 'rgba(28,39,76,0.35)',
        }}
      >
        {getNome(item) || 'Item sem nome'}
        {!item.ativo && (
          <Typography component="span" variant="caption" sx={{ ml: 1, fontWeight: 700, color: 'text.disabled', letterSpacing: '0.04em' }}>
            (oculto)
          </Typography>
        )}
      </Typography>
      {getDescricao(item) && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontStyle: 'italic',
            mt: 0.25,
            display: { xs: 'none', md: '-webkit-box' },
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {getDescricao(item)}
        </Typography>
      )}
    </Box>

    <Box sx={{ flexShrink: 0, textAlign: 'right', minWidth: 88 }}>
      <Typography variant="body1" sx={{ fontWeight: 800, color: menuPalette.orange, whiteSpace: 'nowrap' }}>
        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.preco || 0)}
      </Typography>
    </Box>

    {!showHandle && (
      <Stack direction="row" alignItems="center" spacing={0.25} sx={{ flexShrink: 0 }}>
        <Tooltip title={item.ativo ? `Disponível no ${channelLabel} - clique para ocultar` : `Indisponível no ${channelLabel} - clique para exibir`}>
          <Switch
            size="small"
            checked={!!item.ativo}
            onChange={(e) => onToggleActive?.(e.target.checked)}
          />
        </Tooltip>
        <Divider orientation="vertical" flexItem sx={{ mx: 0.5, my: 0.75, borderColor: menuPalette.border }} />
        <Box
          className="item-secondary-actions"
          sx={{ display: 'flex', transition: 'opacity .2s ease', opacity: { xs: 1, md: 0.5 } }}
        >
          <Tooltip title="Editar item">
            <IconButton size="small" onClick={onEdit} aria-label="Editar item"><Edit fontSize="small" /></IconButton>
          </Tooltip>
          <Tooltip title="Excluir item">
            <IconButton size="small" color="error" onClick={onDelete} aria-label="Excluir item"><Delete fontSize="small" /></IconButton>
          </Tooltip>
        </Box>
      </Stack>
    )}
  </Box>
);

export default ItemRow;
